import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import { SxProps } from '@mui/material/styles';
import { RedirectCard } from 'common/ui/RedirectCard';

const container: SxProps = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  p: 4
};

type Props = {
  redirectType: 'success' | 'failed';
};

export const EmailOptOutPage: React.FC<Props> = ({ redirectType }) => {
  const { title, message } = useMemo(() => {
    if (redirectType === 'success') {
      return {
        title: 'Opt out successful',
        message: 'You will no longer receive job notifications from us'
      };
    }

    return {
      title: 'Opt out failed',
      message: "We're sorry, something has gone wrong"
    };
  }, [redirectType]);

  return (
    <Box sx={container}>
      <RedirectCard
        redirectType={redirectType}
        title={title}
        message={message}
      />
    </Box>
  );
};
